import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../shared/colors';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import {Button} from '@material-ui/core';
import {useHistory} from 'react-router-dom'
import messages from "./messages";

const useStyles = makeStyles( theme => ({
    backButton: {
        backgroundColor: colors.dhcsBlue,
        '&:hover':{
            backgroundColor: colors.dhcsBlue,
        },
        '&:focus-visible': {
            outline: `3px solid ${colors.dhcsBlue}`,
            outlineOffset: '1px'
        }
    }
}))

export default function BackButton(props) {
    const {
        size='medium',
        onClick=()=>history.goBack(),
        } = props
    const classes = useStyles()
    const history = useHistory()
    const {backButton: { id, defaultMessage: text }} = messages;

    return (
        <div id={`${id}_${Math.floor(Math.random()*(50000-2 +1) + 2)}`} data-testid={id}>
            <Button
                className={classes.backButton}
                disableRipple
                onClick={onClick}
                size={size}
                color='primary'
                variant='contained'
                startIcon={<FastRewindIcon />}
            >
                {text}
            </Button>
        </div>
    )
}
